
import styles from '../ModuleCss/HomePage.module.css'

function LogoSlider(){

    return (
    <div className={styles.slider}>
            <div className= {styles.slideTrack}>
                <div class={styles.slide}>
                    <img src="https://webstatic.chargebee.com/assets/web/520/images/customers/logos/logos-sprite.png" height="50" width="1078" alt="" />
                </div>
                <div class={styles.slide}>
                    <img src="https://webstatic.chargebee.com/assets/web/520/images/customers/logos/logos-sprite.png" height="50" width="1078" alt="" />
                </div>
                <div class={styles.slide}>
                    <img src="https://webstatic.chargebee.com/assets/web/520/images/customers/logos/logos-sprite.png" height="50" width="1078" alt="" />
                </div>
                {/* <div class={styles.slide}>
                    <img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/557257/3.png" height="100" width="150" alt="" />
                </div>
                <div class={styles.slide}>
                    <img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/557257/4.png" height="100" width="150" alt="" />
                </div>
                <div class={styles.slide}>
                    <img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/557257/5.png" height="100" width="150" alt="" />
                </div>
                <div class={styles.slide}>
                    <img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/557257/6.png" height="100" width="150" alt="" />
                </div>
                <div class={styles.slide}>
                    <img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/557257/7.png" height="100" width="150" alt="" />
                </div>
                <div class={styles.slide}>
                    <img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/557257/1.png" height="100" width="150" alt="" />
                </div>
                <div class="slide">
                    <img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/557257/2.png" height="100" width="150" alt="" />
                </div>
                <div class="slide">
                    <img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/557257/3.png" height="100" width="150" alt="" />
                </div>
                <div class="slide">
                    <img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/557257/4.png" height="100" width="150" alt="" />
                </div>
                <div class="slide">
                    <img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/557257/5.png" height="100" width="150" alt="" />
                </div>
                <div class="slide">
                    <img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/557257/6.png" height="100" width="150" alt="" />
                </div>
                <div class="slide">
                    <img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/557257/7.png" height="100" width="150" alt="" />
                </div> */}
            </div>
</div>
    )
}

export default LogoSlider